<!--  -->
<template>
  <el-container class="container" id="container" v-title data-title="课程列表">
    <linglanHeader></linglanHeader>
    <el-main>
      <div class="header">
        <div class="header-con clearFix">
          <img class="bg" src="@/assets/images/index_bg.png" alt="" />
          <img class="avatar fl" :src="userInfo.face" alt="" />
          <div class="info fl">
            <h2>{{ userInfo.alias }}，欢迎归来</h2>
            <!-- <p>11</p> -->
          </div>
        </div>
      </div>
      <div class="main-title">
        <div class="main-title-con">我的课程</div>
      </div>
      <!-- <div class="main">
              {empty name="courses"}
              <div class="empty-div">
                <p>您还未购买过视频课程，请访问灵兰中医App，</p>
                <p>或中医书友会微信公众号“在线课程”栏目，了解相关课程信息</p>
              </div>
              {else /}
          】】
              {/empty}
            </div> -->
      <div class="main" v-show="isShow">
        <ul v-if="courseList" class="clearFix courses-ul">
          <li
            class="courses-li"
            v-for="item in courseList"
            @click="toUnion(item)"
            :key="item.courseId"
          >
            <img :src="item.photo" alt="" />
            <p>{{ item.title }}</p>
          </li>
        </ul>
        <div v-else class="empty-div">
          <p>您还未购买过视频课程，请访问灵兰中医App，</p>
          <p>或中医书友会微信公众号“在线课程”栏目，了解相关课程信息</p>
        </div>
      </div></el-main
    >
    <el-footer height="100px"
      ><div class="footer-wraper">
        <div class="footer">
          <div class="img-wraper fl">
            <img src="@/assets/images/download.jpg" alt="" />
          </div>
          <div class="info fl">
            <p>
              为了保护您的听课权益，本网站不支持与APP端、H5端同时在线，三端有且只能一端在线。如您在APP或H5端再次登录，PC端将自动退出登录。
            </p>
            <b>咨询建议请扫描二维码添加客服企业微信</b>
          </div>
          <div class="copyright fr">
            © 2017 北京灵兰精诚中医科技有限公司版权所有<br />京ICP备15057334号
            <router-link tag="a" target="_blank" :to="{ name: 'privacyPolicy' }"
              ><span style="margin-left: 15px">隐私及个人信息保护政策</span></router-link
            >
            <br />
            <router-link tag="a" target="_blank" :to="{ name: 'permit' }"
              >出版物许可</router-link
            >
          </div>
          <div class="line fr"></div>
        </div></div
    ></el-footer>
  </el-container>
</template>

<script>
import linglanHeader from "@/components/header";
import { userUrl } from "@/config/deployUrl";
import AES from "@/libs/AES.js";
export default {
  components: {
    linglanHeader,
  },
  computed: {
    appid() {
      return this.$store.state.appid;
    },
    scope() {
      return this.$store.state.scope;
    },
    redirectUri() {
      return this.$store.state.redirectUri;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  data() {
    return {
      courseList: null,
      isShow: false,
    };
  },
  methods: {
    getMyCourseList() {
      console.log(localStorage.getItem("token"));
      let token = localStorage.getItem("token");
      let reqdata = {
        token: token,
      };
      this.$request.post("/api/userCourse/getMyCourseList", reqdata).then((res) => {
        console.log("请求课程列表");
        console.log(res);
        this.isShow = true;
        this.courseList = res;
        // console.log(JSON.parse(sessionStorage.getItem("userInfo")))
      });
    },
    pcQrCodeLogin() {
      let reqdata = {
        loginCode: this.$route.query.code,
      };
      this.$request.post("/api/login/pcQrCodeLogin", reqdata, "", userUrl).then((res) => {
        console.log("登录");
        console.log(res);
        localStorage.setItem("token", res.token);
        localStorage.setItem("code", this.$route.query.code);
        localStorage.setItem("userInfo", JSON.stringify(res.userBaseInfo));
        this.$store.commit("STORE_USERINFO", res.userBaseInfo);
        this.getMyCourseList();
      });
    },
    toUnion(val) {
      console.log(val);
      // this.$router.push('/login')
      this.$router.push({
        name: "union",
        query: {
          courseId: AES.encrypt(val.courseId),
          speaker: AES.encrypt(val.speaker),
          title: AES.encrypt(val.title),
        },
      });
    },
  },

  //生命周期 - 创建完成（访问当前this实例）
  created() {
    // console.log("用户信息")
    // console.log(JSON.parse(sessionStorage.getItem("userInfo")))
    let code = localStorage.getItem("code");
    // console.log("判断code")
    // console.log(code == this.$route.query.code)
    if (
      localStorage.getItem("token") &&
      (code == this.$route.query.code || !this.$route.query.code)
    ) {
      this.getMyCourseList();
    } else {
      if (!this.$route.query.code) {
        this.$router.push("/login");
        return;
      }
      this.pcQrCodeLogin();
    }
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    // $("#container").css({ "min-height": $(document).outerHeight() + "px" });
    // $(".footer-wraper").css({ display: "block" });
    // console.log(this.$route.query.code);
  },
};
</script>

<style scoped>
/* @import url(); 引入css类 */
@import url("../../assets/css/common.css");
@import url("../../assets/css/main.css");
@import url("../../assets/css/courselist.css");
.container {
  padding-bottom: 0px !important;
}
.main {
  width: 100%;
  /* height: 340px; */
  position: relative;
}
.main img {
  width: 1100px;
  height: 100%;
  margin: 0 auto;
}
.main .code-wraper {
  width: 360px;
  height: 380px;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50px;
  margin-left: -180px;
  border-radius: 8px;
  box-shadow: 0px 2px 3px #d3d2d2;
  -moz-box-shadow: 0px 2px 3px #d3d2d2;
  -webkit-box-shadow: 0px 2px 3px #d3d2d2;
}
#wxcode {
  width: 220px;
  height: 220px;
  position: relative;
}
.main .login-info {
  width: 360px;
  margin: 110px auto 50px;
  line-height: 24px;
  font-size: 16px;
  color: #585858;
}

.el-main {
  min-height: calc(100vh - 200px);
}
.el-footer {
  padding: 0px !important;
}
.el-header {
  padding: 0px;
}
</style>
